import React, { Component } from "react";
import Image from "react-bootstrap/Image";
import Container from "react-bootstrap/Container";
import "./style.css";

export default class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      awards: [],
      isUserScrolling: false,
    };
    this.scrollContainerRef = React.createRef();
    this.isDragging = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.scrollTimeout = null;
  }

  componentDidMount() {
    this.fetchAwardsData();
    this.startAutoScrolling();
  }

  componentWillUnmount() {
    clearInterval(this.autoScrollInterval);
    clearTimeout(this.scrollTimeout);
  }

  fetchAwardsData = async () => {
    try {
      const response = await fetch("/awards.json");
      const data = await response.json();
      this.setState({ awards: data }, () => {
        const scrollContent = document.querySelector(".scrollContent");
        scrollContent.innerHTML += scrollContent.innerHTML;
      });
    } catch (error) {
      console.error("Error fetching awards data:", error);
    }
  };

  startAutoScrolling = () => {
    const scrollContent = document.querySelector(".scrollContent");
    const scrollSpeed = 2;
    let scrollPosition = 0;

    this.autoScrollInterval = setInterval(() => {
      if (!this.state.isUserScrolling) {
        scrollPosition -= scrollSpeed;
        if (Math.abs(scrollPosition) >= scrollContent.scrollWidth / 2) {
          scrollPosition = 0;
        }
        scrollContent.style.transform = `translateX(${scrollPosition}px)`;
      }
    }, 30);
  };

  handleMouseDown = (e) => {
    this.isDragging = true;
    this.startX = e.pageX - this.scrollContainerRef.current.offsetLeft;
    this.scrollLeft = this.scrollContainerRef.current.scrollLeft;
    this.setState({ isUserScrolling: true });
  };

  handleMouseMove = (e) => {
    if (!this.isDragging) return;
    e.preventDefault();
    const x = e.pageX - this.scrollContainerRef.current.offsetLeft;
    const walk = (x - this.startX) * 2;
    this.scrollContainerRef.current.scrollLeft = this.scrollLeft - walk;
  };

  handleMouseUp = () => {
    this.isDragging = false;
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      this.setState({ isUserScrolling: false });
    }, 2000);
  };

  render() {
    const { awards } = this.state;

    return (
      <div className="AwardContainer">
        <div
          className="RateUsLogo"
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "40px",
          }}
        >
          <a href="https://ebadge.bestweb.lk/api/v1/clicked/examhub.lk/BestWeb/2025/Rate_Us">
            <img
              src="https://ebadge.bestweb.lk/eBadgeSystem/domainNames/examhub.lk/BestWeb/2025/Rate_Us/image.png"
              alt="logo"
              width="150"
              height="150"
            />
          </a>
        </div>
        <Container>
          <center>
            <div className="AwardHeaderTextDiv">
              <span className="AwardHeaderText">
                A Nationally and Internationally Award-Winning Education App
              </span>
            </div>
            <div
              className="awardsImgScroll"
              ref={this.scrollContainerRef}
              onMouseDown={this.handleMouseDown}
              onMouseMove={this.handleMouseMove}
              onMouseLeave={this.handleMouseUp}
              onMouseUp={this.handleMouseUp}
            >
              <div className="scrollContent">
                {awards.map((award, index) => (
                  <div className="awardFrame" key={index}>
                    <Image src={award.image} alt="awardLogo" />
                    <div>
                      <span className="awardName">{award.name}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </center>
        </Container>
      </div>
    );
  }
}
